import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/service-request-set";

export const saveServiceRequestSet = srs => {
    const url = API_PATH + '/save';
    return axios.post(url, srs);
}

export const getServiceRequestSetById = srsId => {
    const url = API_PATH + '/getbyid/' + srsId;
    return axios.get(url);
}

export const deleteServiceRequestSetById = srsId => {
    const url = API_PATH + '/mark-delete/' + srsId;
    return axios.delete(url);
}

export const pagingServiceRequestSet = searchObj => {
    const url = API_PATH + '/search-by-page';
    return axios.post(url, searchObj);
}